import React from 'react'
import { JsonLd, JsonLdProps } from './JsonLd'
import { Movie } from './types'

export interface MovieJsonLdProps extends JsonLdProps, Movie {}

export const MovieJsonLd: React.FC<MovieJsonLdProps> = ({ type = 'Movie', keyOverride, ...rest }: MovieJsonLdProps) => {
  return <JsonLd type={type} keyOverride={keyOverride} {...rest} scriptKey="Movie" />
}
